import axios from "axios";
import { urlConfig } from "../../config/urlConfig";
import { getCall } from "../httpService";
import LocalStorageUtil from "../../utils/localStorage";

const baseUrl = process.env.REACT_APP_API_URL;
const GetTokenURL = urlConfig.GetAntiForgeryToken;
const token = LocalStorageUtil.getItem("token");

const apiClient = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  },
});

export const GetAntiForgeryToken = async () => {
  try {    
    const response = await getCall(GetTokenURL,'');    
    if (response == null) {
        return;
      }
      LocalStorageUtil.setItem("antiforgery", response.AntiForgeryToken);
      LocalStorageUtil.setItem("antiforgerycookie", response.CookieAntiForgeryToken);
  } catch (error) {
    console.error("Error in GetAntiForgeryToken data fetching ", error);
  }
};